import { RouteObject } from 'react-router-dom';

import { AuthGuard } from './components/AuthGuard';
import Login from './components/login/login';
import ForgotPasswordForm from './components/login/ForgotPassword';
import ResetPassword from './components/login/ResetPassword';

export interface AuthRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: AuthRoute[];
}

export const authRoutes: AuthRoute[] = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <Login />
      </AuthGuard>
    ),
  },
  {
    path: '/login',
    element: (
      <AuthGuard>
        <Login />
      </AuthGuard>
    ),
  },
  {
    path: '/forgot-password',
    element: (
      <AuthGuard>
        <ForgotPasswordForm/>
        {/* <ForgotPasswordForm /> */}
      </AuthGuard>
    ),
  },
  {
    path: '/reset-password',
    element: (
      <AuthGuard>
        <ResetPassword  />
      </AuthGuard>
    ),
  },
];
